export const black1000 = '#000000';
export const black800 = '##3e3d3a';
export const black555 = '#74726a';
export const black400 = '#aeaba3';

export const lateOceanColorPalette = {
  '--color-late-ocean': '#624af7',
  '--color-late-ocean-light-1': '#7b66ff',
  '--color-late-ocean-light-2': '#a99cff',
  '--color-late-ocean-light-3': '#efc2ff',

  '--color-warm-embrace': '#f4d6ff',
  '--color-warm-embrace-light-1': '#f9e8ff',

  '--color-moon-purple': '#d5cfff',
  '--color-moon-purple-light-1': '#f2f0ff',

  '--color-black-1000': black1000,
  '--color-black-800': black800,
  '--color-black-555': black555,
  '--color-black-400': black400,
  '--color-black-200': '#dedad2',
  '--color-black-100': '#ebe9e5',
  '--color-black-50': '#f4f3ef',
  '--color-black-white': '#FFFFFF',

  '--color-viride': '#08d48e',
  '--color-english-vermillon': '#f57d7d',
  '--color-gold-crayola': '#ffd35e',
  '--color-aero': '#6e96ff',
};
